import { render } from "./GCash.vue?vue&type=template&id=118e8e04&scoped=true"
import script from "./GCash.vue?vue&type=script&lang=js"
export * from "./GCash.vue?vue&type=script&lang=js"

import "./GCash.vue?vue&type=style&index=0&id=118e8e04&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\ihcpayment\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118e8e04"]])

export default __exports__